import { useRootStore } from '~/store/root'
import { useIdentityStore } from '~/store/identity'
import { useBorrowerStore } from '~/store/borrower'
import routeAuth from '~/libs/route-authentication'

export default defineNuxtRouteMiddleware(async (to, from) => {
  const nuxtApp = useNuxtApp()
  const { $pinia } = nuxtApp
  const businessSelectUrl = useIdentityStore($pinia).businessSelectUrl

  if (useRootStore($pinia).isLoggedIn && !useBorrowerStore($pinia)?.borrower && to.path !== businessSelectUrl) {
    return nuxtApp.runWithContext(() => navigateTo(businessSelectUrl))
  }
})
